import React from "react";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomSelect from "../../../components/CustomForm/CustomSelect";
import CheckRender from "../../../components/Common/CheckRender";
import CustomCheckbox from "../../../components/CustomForm/CustomCheckbox";
import {
  dataTipoServicioTodos,
  dataTipoTelefono,
} from "../../../utils/LocalData";
import {
  FormWrapper,
  Form,
  FormGroup,
  Label,
} from "../../../components/CustomForm/FormStyles";
import Colors from "../../../themes/Colors";
import useEmpresa from "../../../hooks/useEmpresa";

const DetalleAutorizacion = ({
  fecha,
  tipoTelefono,
  telefono,
  tipoServicio,
  correo,
  esArl,
  medicoPrescriptor,
  diagnostico,
  requiereFisico,
  zona,
  provincia,
  observaciones,
  prestadorEsPapperFree,
  diagnosticoDefinitivo,
}) => {
  const empresa = useEmpresa();

  return (
    <FormWrapper borderColor={empresa?.COLOR_PRINCIPAL}>
      <Form>
        <CheckRender allowed={prestadorEsPapperFree}>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Requiere Físico"}
              label={"Requiere Físico"}
              value={requiereFisico}
              disabled={true}
            />
          </FormGroup>
        </CheckRender>
        <FormGroup>
          <CustomInput
            type={"date"}
            placeholder={"Fecha"}
            label={"Fecha"}
            value={fecha}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomSelect
            options={dataTipoTelefono}
            label={"Tipo Teléfono"}
            value={tipoTelefono}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={"Teléfono"}
            label={"Teléfono"}
            value={telefono}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomSelect
            options={dataTipoServicioTodos}
            label={"Tipo de Servicio"}
            value={tipoServicio}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={"Correo Electrónico"}
            label={"Correo Electrónico"}
            value={correo}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={"Médico Prescriptor"}
            label={"Médico Prescriptor"}
            value={medicoPrescriptor}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={"Diagnóstico"}
            label={"Diagnóstico"}
            value={diagnostico}
            disabled={true}
          />
        </FormGroup>
        <CheckRender allowed={requiereFisico === "No"}>
          <FormGroup>
            <Label font={empresa?.LETRA_PRINCIPAL}>
              Diagnóstico Definitivo?
            </Label>
            <CustomCheckbox
              checked={diagnosticoDefinitivo}
              checkedColor={empresa?.COLOR_PRINCIPAL}
              uncheckedColor={Colors.blueTransparent}
              checkmarkColor={Colors.white}
              disabled={true}
            />
          </FormGroup>
        </CheckRender>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={"ARL"}
            label={"ARL"}
            value={esArl}
            disabled={true}
          />
        </FormGroup>
        <CheckRender allowed={requiereFisico === "No"}>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Zona"}
              label={"Zona"}
              value={zona}
              disabled={true}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Provincia"}
              label={"Provincia"}
              value={provincia}
              disabled={true}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Observaciones"}
              label={"Observaciones"}
              value={observaciones}
              disabled={true}
            />
          </FormGroup>
        </CheckRender>
      </Form>
    </FormWrapper>
  );
};

export default DetalleAutorizacion;
